var React = require("react");
var PropTypes = require("prop-types");
const createReactClass = require('create-react-class');
var _ = require('underscore');

/**
 * Defines a set of option inputs that will submit a single value.
 */
const OptionSet = createReactClass({
	getInitialState() {
		return {
			value: this.props.value || ''
		};
	},

	componentWillMount() {
		this.props.attachToForm(this);
		if (_.has(this.props, 'onSetValue')) this.props.onSetValue(this.props.value);
	},

	componentWillUpdate(nextProps, nextState) {
		if (this.state.value !== nextState.value) {
			if (_.has(this.props, 'onSetValue')) this.props.onSetValue(nextState.value);
		}
	},

	componentWillUnmount() {
		this.props.detachFromForm(this);
	},

	handleOptionSelect(value) {
		this.setState({ value });
	},

	renderOption: function(option, i) {
		return (
			<div className="option-set-item">
				<input
					onClick={() => this.handleOptionSelect(option.value)}
					type="radio"
					name={this.props.name}
					id={this.props.name + i}
					value={option.value}
					checked={this.state.value === option.value}
					aria-describedby={option.description && this.props.name + i + '-description'}
				/>
				<div className="option-set-item__label">
					<label htmlFor={this.props.name + i}>{option.name}</label>
					{option.description
					&& (
						<p id={this.props.name + i + '-description'} className="option-set-item__description">
							{option.description}
						</p>
					)
					}
				</div>
			</div>
		);
	},

	render() {
		return (
			<div className="option-set">
				{this.props.options.map((option, i) => this.renderOption(option, i))}
			</div>
		);
	}
});

OptionSet.propTypes = {
	name: PropTypes.string.isRequired,
	options: PropTypes.arrayOf(PropTypes.shape({
		name: PropTypes.string.isRequired,
		description: PropTypes.string,
		value: PropTypes.string.isRequired,
	})).isRequired,
	value: PropTypes.string,
	onSetValue: PropTypes.func,
};

module.exports = OptionSet;
